/* eslint-disable react-hooks/refs */
import { useController } from 'react-hook-form';
import { Input, type InputProps } from './input';
import { cn } from '@talentmesh/ui/lib/utils';

export type RHFDefaultInputProps = Omit<
    InputProps,
    'name' | 'value' | 'defaultValue' | 'onChange' | 'onBlur' | 'ref'
> & {
    name: string;
    displayValue?: string;
};

function RHFDefaultInput({
    name,
    id,
    type = 'text',
    displayValue,
    className,
    disabled,
    autoComplete = 'off',
    ...inputRest
}: RHFDefaultInputProps) {
    const { field, fieldState } = useController({ name });
    const error = fieldState.error;
    const invalid = error !== undefined;
    const inputId = id ?? name;
    const mergedClassName = cn(
        'transition-colors duration-200',
        error &&
            'border-destructive focus-visible:border-destructive focus-visible:ring-destructive dark:focus-visible:border-destructive/50 dark:focus-visible:ring-destructive/50',
        className,
    );

    return (
        <Input
            id={inputId}
            type={type}
            name={field.name}
            value={displayValue ?? field.value ?? ''}
            onChange={field.onChange}
            onBlur={field.onBlur}
            ref={field.ref}
            className={mergedClassName}
            aria-invalid={invalid}
            autoComplete={autoComplete}
            disabled={disabled}
            {...inputRest}
        />
    );
}

export { RHFDefaultInput };
